import { render } from "./MessageBox.vue?vue&type=template&id=c3e6ec5a&scoped=true"
import script from "./MessageBox.vue?vue&type=script&lang=js"
export * from "./MessageBox.vue?vue&type=script&lang=js"

import "./MessageBox.vue?vue&type=style&index=0&id=c3e6ec5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3e6ec5a"]])

export default __exports__